// `label` is what the UI shows; `apiName` is the city string the backend
// expects in request payloads (e.g. "Bangalore", not "Bengaluru").
// City filename casing here must match the actual files in public/icons/city/
// exactly (case-sensitive on the deployed filesystem) — note "kokata.svg" is a
// pre-existing typo in that asset's filename, not a typo here.
export const CITIES = [
  { id: "bengaluru", label: "Bengaluru", apiName: "Bangalore", iconSrc: "/icons/city/bengaluru.svg" },
  { id: "delhi", label: "Delhi", apiName: "Delhi", iconSrc: "/icons/city/delhi.svg" },
  { id: "kolkata", label: "Kolkata", apiName: "Kolkata", iconSrc: "/icons/city/kokata.svg" },
  { id: "jaipur", label: "Jaipur", apiName: "Jaipur", iconSrc: "/icons/city/Jaipur.svg" },
];

// The service is currently only live in one city. The city popup is static
// around this (no selection UI, nothing persisted) until more cities launch —
// at that point this becomes a real selection backed by storage again, and
// CITIES above already has the other cities ready to go.
export const LIVE_CITY_ID = "bengaluru";
